import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import chat from './chat'
import env from '../config/env';
import Router from '../router/'
import Navigation from '../router/index'
import i18n from '../libs/i18n'

Vue.use(Vuex)

const baseURL = env.baseURL;
const normalURL = env.normalURL;

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    chat,
    Navigation
  },
  strict: process.env.DEV,
  state: {
    user: {
      name: '',
      photo: '',
      login: '',
      access_nivel: 0,
      group_permission_id: '',
      perfil_id: 0,
      id: 0,
      abilities: [],
      locale: 'pt'
    },
    selected_node: JSON.parse(localStorage.getItem('selected_node')) || null,
    step_alerts: {},
    // Estado do operador logado, para a bolinha do avatar: operating | idle | paused.
    operator_status: 'operating',
    authenticated: false,
    notifications: 0,
    token: '',
    api: baseURL,
    url: normalURL,
    breadcrumbs: [{ name: "Home", route: "/" }],
    navigation: [],
  },
  getters: {
    token: state => {
      return state.token;
    },
    authenticated: state => {
      if (state.token == null || state.token == 'null') {
        return false;
      }

      return state.authenticated;
    },
    logo: state => {
      return state.logo;
    },
    user: state => {
      return state.user;
    },
    can: state => ability => {
      return state.user.abilities.includes(ability);
    },
    selectedNode: state => {
      return state.selected_node;
    },
    api: state => {
      return state.api;
    },
    breadcrumbs: state => {
      return state.breadcrumbs;
    },
    navigation: state => {
      return Navigation.options.routes;
    }
  },
  mutations: {
    auth(state, token) {

      if (token != null && token != undefined) {
        state.authenticated = true;
        state.token = token;

        // NÃO limpar o localStorage aqui — esta mutation também roda no boot
        // normal da SPA (action `initialize`, chamada em todo F5, não só no
        // login) pra restaurar o token salvo. Limpar aqui apagava
        // selected_node (e tudo mais) a cada recarregamento de página. Quem
        // precisa de um localStorage limpo (login novo) faz isso
        // explicitamente antes de chamar este mutation (ver Login.vue).
        localStorage.setItem('token', token);

        this.commit('profileUpdate');
      }
    },
    updateNotifications(state, data) {
      state.notifications = Number(state.notifications) + 1;
    },
    profileUpdate(state) {
      axios.post(state.api + 'me', {
        token: state.token
      })
        .then(response => {
          state.user.id = response.data.id;
          state.user.name = response.data.name;
          state.user.login = response.data.login;
          state.user.professional_name = response.data.professional_name || null;
          state.user.access_nivel = response.data.access_nivel;
          state.user.group_permission_id = response.data.group_permission_id;
          state.user.photo = state.url + "user/image/" + response.data.id;
          state.user.abilities = response.data.abilities || [];
          state.user.locale = response.data.locale || 'pt';
          i18n.locale = state.user.locale;

          // Idioma escolhido na tela de login (antes de existir sessão pra
          // salvar) — aplica e persiste agora que já temos o usuário autenticado.
          const loginLocale = localStorage.getItem('loginLocale');
          if (loginLocale && loginLocale !== state.user.locale) {
            state.user.locale = loginLocale;
            i18n.locale = loginLocale;
            axios.post(state.api + 'user/locale', { locale: loginLocale }).catch(() => {});
          }
          localStorage.removeItem('loginLocale');

          localStorage.setItem('accept_terms', response.data.accept_terms);
          localStorage.setItem('group_permission_id', response.data.group_permission_id);
          localStorage.setItem('access_nivel', response.data.access_nivel);
          localStorage.setItem('abilities', JSON.stringify(state.user.abilities));

          if (response.data.perfil_id == 20) {
            Router.push('/condutor/index');
          }

          // context.commit('auth', token);

        })
        .catch(error => {
          localStorage.clear();

          Router.push('/login');
        });
    },
    updateBreadCrumbs(state, newRoute) {
      if (state.breadcrumbs.length > 1) {
        state.breadcrumbs.pop();
      }
      state.breadcrumbs.push(newRoute)
    },
    setNode(state, node) {
      state.selected_node = node;
      if (node) {
        localStorage.setItem('selected_node', JSON.stringify(node));
      } else {
        localStorage.removeItem('selected_node');
      }
    },
    setOperatorStatus(state, status) {
      state.operator_status = status
    },
    setStepAlerts(state, map) {
      state.step_alerts = map || {};
    },
    setLocale(state, locale) {
      state.user.locale = locale;
      i18n.locale = locale;
    }
  },
  actions: {
    changeLocale(context, locale) {
      context.commit('setLocale', locale);

      return axios.post(context.state.api + 'user/locale', { locale });
    },
    initialize(context) {
      const token = localStorage.getItem('token');
      context.commit('auth', token);

      if (token) {
        context.dispatch('fetchStepAlerts');
      }
    },

    fetchStepAlerts(context) {
      return axios.get(context.state.api + 'node_step_alerts/current')
        .then(response => {
          context.commit('setStepAlerts', response.data.data);
        })
        .catch(() => {
          context.commit('setStepAlerts', {});
        });
    }
  },
})
